import httpClient from "./httpClient";

const fetchSmartReport = (hash: string, locale: string, source: string) => {
  const params = { h: hash, locale, source };
  return httpClient.get("/", { params });
};

export { fetchSmartReport };
